import { Breadcrumbs, Card, colors, Container, Divider, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import menus from '../../helpers/menuRoles';
import PortalHeader from '../portal/PortalHeader';

const Home = ({ userInfo }) => {
  const navigate = useNavigate();

  const [menu, setMenu] = React.useState(menus);

  return (
    <Stack sx={{ backgroundColor: colors.grey[100] }}>
      <Container sx={{ backgroundColor: colors.grey[50] }}>
        <Stack direction='column' sx={{ minHeight: '100vh' }}>
          <Stack direction='column' spacing={2} sx={{ padding: 2, flex: 1 }}>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link underline='hover' color='inherit' href='/portal'>
                Home
              </Link>
            </Breadcrumbs>
            <PortalHeader userInfo={userInfo} />
            <Stack direction='row' spacing={2}>
              <Stack direction='row' sx={{ flexWrap: 'wrap' }} alignItems='flex-start' justifyContent='flex-start'>
                {menu
                  .filter((item) => item.eligible.includes(userInfo.type) && !item.isHidden)
                  .map((item) => (
                    <Card sx={{ height: 150, width: 150, cursor: 'pointer', margin: 2 }} onClick={() => navigate(item.navigate)}>
                      <Stack sx={{ height: '100%', width: '100%' }} direction='column' alignItems='center' justifyContent='space-between'>
                        <Stack sx={{ backgroundColor: 'white', height: 20, width: '100%' }} />
                        <Stack direction={{ xs: 'row', sm: 'column', md: 'column' }} spacing={{ xs: 1 }} alignItems='center' justifyContent='center'>
                          {item.icon}
                          <Typography>{item.label}</Typography>
                        </Stack>

                        <Stack sx={{ backgroundColor: colors.blue[400], height: 20, width: '100%' }} />
                      </Stack>
                    </Card>
                  ))}
              </Stack>
            </Stack>
          </Stack>

          <Stack sx={{ backgroundColor: colors.grey[50], padding: 1 }}>
            <Typography variant='body2' sx={{ textAlign: 'center', color: colors.grey[800], fontWeight: 500 }}>
              Domes - Document Repository &copy; {new Date().getFullYear()} Version {process.env.REACT_APP_VERSION}
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};

export default Home;
